<script setup lang="ts">

</script>

<template>
  <div class="fixed inset-0 flex-center bg-primary-950 px-2">
    <div class="max-w-sm w-full border rounded-xl bg-app px-4 py-6 shadow">
      <app-router-view />
    </div>
  </div>
</template>
